import {
  Navigate,
  useLocation,
  useParams,
  type RouteObject,
} from "react-router-dom";
import { getSellerPath } from "@/lib/routing/portal-urls";
import { defaultLocale } from "@/lib/i18n/portal";

/**
 * Online transactions used to be a page of its own at `/transactions`. It is
 * now the third tab of `/payments`, so the old path forwards instead of
 * 404-ing — sellers bookmark it, and a `?transaction=<id>` deep link is the
 * link a support conversation gets pasted into.
 *
 * The whole search string rides along and `tab=online` is forced on top of it,
 * so `?transaction=<id>` still opens the detail drawer on arrival and any
 * stale `tab` in the old URL cannot land the seller on the wallet.
 *
 * A `PAYMENT_VIEW`-only member arriving here is not stranded: `?tab=online` is
 * exactly the tab that permission grants, and `resolveVisibleTab` in
 * `modules/payments/lib/payments-tabs.ts` keeps it that way.
 */
function TransactionsPathRedirect() {
  const { locale = defaultLocale, storeSlug = "" } = useParams();
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  params.set("tab", "online");
  return (
    <Navigate
      to={`${getSellerPath(locale, storeSlug, "/payments")}?${params.toString()}`}
      replace
    />
  );
}

export const transactionsRoutes: RouteObject[] = [
  {
    path: "transactions",
    element: <TransactionsPathRedirect />,
  },
];
